import React, { Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Progress, ErrorTemplate } from 'next-common-lib';
import i18n from 'i18n';
import Alert from 'components/Common/Popup/Alert';
import Confirm from 'components/Common/Popup/Confirm';
import WizardClosePopup from 'components/Common/Popup/WizardClosePopup';
import UrlLinkInvitation from 'components/IncorporationOfTerms/UrlLinkInvitation';
import WizardMain from 'pages/WizardMain';
import IncorporationOfTerms from 'pages/IncorporationOfTermsPage';
import PrivacyPolicy from 'pages/PrivacyPolicyPage';
import UseTerms from 'pages/UseTermsPage';
import useTitle from 'utils/hook/useTitle';
import UrlLinkError from './components/IncorporationOfTerms/UrlLinkError';

function App() {
  useTitle();

  return (
    <>
      <BrowserRouter>
        <Suspense fallback={<Progress componentType="loading" />}>
          <Routes>
            <Route path="/userapp/wizard/" element={<WizardMain />} />
            <Route
              path="/userapp/register/admin"
              element={
                <UrlLinkError
                  title={i18n.t('MB_M_FREE_SERVICE_END_TITLE')}
                  explanation={i18n.t('MB_M_FREE_SERVICE_END_CONTENTS')}
                />
              }
            />
            <Route path="/userapp/register/:menu" element={<IncorporationOfTerms />} />
            <Route path="/userapp/accountjoin/:link" element={<UrlLinkInvitation />} />
            <Route path="/userapp/privacypolicy" element={<PrivacyPolicy />} />
            <Route path="/userapp/use-terms" element={<UseTerms />} />
            <Route path="/userapp/privacy_policy" element={<PrivacyPolicy />} />
            <Route path="*" element={<ErrorTemplate refTitle="Page Not Found" askBtn refCode="404" service="Employee" />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
      <Alert />
      <Confirm />
      <WizardClosePopup />
    </>
  );
}

export default App;
